'use client';

import Image from 'next/image';
import { Box } from '@mui/material';

type Props = {
  src: string;
  alt: string;
  /** Wider hero spotlight vs standard feature row */
  priority?: boolean;
  maxWidth?: number | string | { xs?: number | string; md?: number | string };
};

/** Phone-framed product shot for feature rows (portrait device mockup). */
export function MarketingSpotlightImage({ src, alt, priority = false, maxWidth = { xs: 280, md: 340 } }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        py: { xs: 1, md: 2 },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          maxWidth,
          // Portrait phone frame — avoid landscape aspect that squashes the mockup
          aspectRatio: '9 / 19',
          maxHeight: { xs: 480, md: 560 },
        }}
      >
        <Image
          src={src}
          alt={alt}
          fill
          sizes="(max-width: 900px) 80vw, 340px"
          style={{ objectFit: 'contain', objectPosition: 'center' }}
          priority={priority}
        />
      </Box>
    </Box>
  );
}
